import { registerPlugin, WebPlugin } from '@capacitor/core';
const LiveUpdates = registerPlugin('LiveUpdates', {
    web: () => new LiveUpdatesWeb(),
});
export const sync = async () => {
    const result = await LiveUpdates.sync();
    if ('failStep' in result) {
        return Promise.reject(result);
    }
    else {
        return Promise.resolve(result);
    }
};
export const reload = async () => {
    await LiveUpdates.reload();
};
class LiveUpdatesWeb extends WebPlugin {
    async sync() {
        return {
            failStep: 'CHECK',
            message: 'Not implemented for web only',
        };
    }
    // eslint-disable-next-line
    async reload() { }
}
export * from './definitions';
//# sourceMappingURL=index.js.map